;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .controller('CoreHorizontalFiltersController', coreHorizontalFiltersController)

  /* @ngInject */
  function coreHorizontalFiltersController ($scope) {
    const api = {}
    this.getApi = () => api

    activate()

    function activate () {}

    $scope.getMoreOptions = (filter, event) => {
      if (typeof filter.getMoreOptions === 'function') {
        filter.getMoreOptions(event, filter)
      }
    }

    $scope.onSearch = (filter, event) => {
      if (typeof filter.onSearch === 'function') {
        filter.onSearch(event, filter)
      }
    }

    $scope.onChange = (filter, event) => {
      if (typeof filter.onChange === 'function') {
        filter.onChange(event, filter)
      }
    }
  }
})()
